import { render, staticRenderFns } from "./unsubscription-setting.vue?vue&type=template&id=3b014a68"
import script from "./unsubscription-setting.vue?vue&type=script&lang=js"
export * from "./unsubscription-setting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports